import { Modal } from "antd";
import useParametrosAreaComum from "features/area-comum/hooks/useParametrosAreaComum";
import useSaveParametrosAreaComum from "features/area-comum/hooks/useSaveParametrosAreaComum";
import { ParametrosAreaComum } from "features/area-comum/typings";
import { useCurrentTenant } from "features/auth/tenant.store";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import FooterModal from "components/Button/FooterModal";

import ParametrosAreaComumForm from "./ParametrosAreaComumForm";
import SkeletonLoading from "./SkeletonLoading";

export interface ModalParametrosProps {
  open: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onSaved?: () => void;
}

function ModalParametros({ open, onSaved, onClose }: ModalParametrosProps) {
  const { tenant } = useCurrentTenant();

  const { isLoading: isLoadingSave, mutate: handleSave } =
    useSaveParametrosAreaComum(tenant.id);

  const { data: parametros, isFetching: isLoadingParametros } =
    useParametrosAreaComum(tenant.id);

  const { control, handleSubmit, reset, watch, setValue } =
    useForm<ParametrosAreaComum>({
      defaultValues: parametros,
    });

  useEffect(() => {
    reset(parametros);
  }, [parametros, reset]);

  const onSubmit = (form: ParametrosAreaComum) => {
    handleSave(form, {
      onError: (err) => {
        showErrorAxios(err);
      },
      onSuccess: () => {
        showSuccess();
        onSaved?.();
        onClose?.();
      },
    });
  };

  return (
    <Modal
      visible={open}
      title={"Parâmetros"}
      onCancel={onClose}
      width={"800px"}
      destroyOnClose
      footer={
        <FooterModal
          primaryButtonText="Salvar alterações"
          isDisabled={isLoadingSave || isLoadingParametros}
          onClose={onClose}
          isLoadingSave={isLoadingSave}
          onSubmit={handleSubmit(onSubmit)}
          showRegisterAnother={false}
          registerAnother={false}
        />
      }
    >
      {isLoadingParametros ? <SkeletonLoading /> : null}

      {!isLoadingParametros ? (
        <ParametrosAreaComumForm
          setValue={setValue}
          control={control}
          watch={watch}
        />
      ) : null}
    </Modal>
  );
}

export default ModalParametros;
